import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'

const selectedProjectsSlice = (prefix: PrefixType, initialState = []) =>
    createSlice({
        name: `${prefix}/selectedProjects`,
        initialState,
        reducers: {
            selectAllProjects: (state, action) => action.payload,
            addProject: (state, action: PayloadAction<Record<string, any>>) => [...state, action.payload],
            removeProject: (state, { payload: { valueField, project } }) =>
                state.filter((el) => el[valueField] !== project[valueField]),
            resetSelectedProjects: () => initialState,
        },
    })

const selectedProjects = (prefix: PrefixType, initialState = []) => selectedProjectsSlice(prefix, initialState).reducer

export const selectedProjectsActions = (prefix: PrefixType) => selectedProjectsSlice(prefix).actions

export default selectedProjects
